// extracted by mini-css-extract-plugin
export default {"container":"alert-modal_container__qz86p","ctaRow":"alert-modal_ctaRow__eq-y2","ctaCol":"alert-modal_ctaCol__+ee22","cta":"alert-modal_cta__ijbgM"};